import React , { useState , useEffect } from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import ReCAPTCHA from "react-google-recaptcha";

import {NotificationContainer, NotificationManager} from 'react-notifications';

import 'react-notifications/lib/notifications.css';

const recaptchaRef = React.createRef();


const ContactUs =(props) => {
    const [statments,setStatments] = useState(undefined)
    const [pageData,setPageData] = useState(undefined)
    const [pageHtmlData,setPageHtmlData] = useState(undefined)
    const [languageInfo,setLanguageInfo] = useState(undefined);    

    const [name,setName] = useState(undefined)
    const [email,setEmail] = useState(undefined)
    const [subject,setSubject] = useState(undefined)
    const [showSubmit,setShowSubmit] = useState(false)
        
    useEffect(()=>{
        async function getLanguageInfo(){
            var languageCode;
            var responseResultLanguageinfo
            if (new URLSearchParams(props.location.search).get("lang")!=null)
            {
                //console.log('langFromURL: ',new URLSearchParams(props.location.search).get("lang"));
                //console.log('langFromSubDomain: ',window.location.host.split(".")[0]);
                languageCode = new URLSearchParams(props.location.search).get("lang");
                responseResultLanguageinfo = await webapi.get('pages/languageInfo/'+languageCode);
                //console.log(languageInfo);
            }else{
                responseResultLanguageinfo = {data:[{Code:"fa",Title:"فارسی",Direction:"rtl"}]};
            }
            
            // console.log(responseResultLanguageinfo.data.length);
            // console.log(responseResultLanguageinfo.data);
            
            if (responseResultLanguageinfo && responseResultLanguageinfo.data && responseResultLanguageinfo.data.length>0){
                setLanguageInfo(responseResultLanguageinfo.data);
                //setState({lang : responseResultLanguageinfo.data[0].Code});
                document.getElementsByTagName('html')[0].setAttribute("lang", responseResultLanguageinfo.data[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("dir", responseResultLanguageinfo.data[0].Direction);
            }
        }

        getLanguageInfo ();

        //getPage();
        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         setLog('pages/log/books_'+props.match.params.bookgroupcode+'/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => setLog('pages/log/books_'+props.match.params.bookgroupcode+'/visit/'+err));
    },[])


    useEffect(()=>{
        async function getPage() {
            if (languageInfo){
                    const pageList = await webapi.get('pages/datapages/703/'+languageInfo[0].Code);
                    //console.log(pageList);
                    setPageData(pageList.data)
                }else{
                    const pageList = await webapi.get('pages/datapages/703/fa');
                    //console.log(pageList);
                    setPageData(pageList.data);
                }
                if (languageInfo)
                {
                    const pageHtml = await webapi.get('pages/htmlpages/703/'+languageInfo[0].Code);   
                    //console.log(bodyList);     
                    setPageHtmlData(pageHtml.data)
                }
            }
        getPage();
    },[languageInfo])


    

    // async getPage() {
    //     if (LanguageInfo)
    //     {
    //         const pageList = await webapi.get('pages/datapages/703/'+LanguageInfo[0].Code);
    //         //console.log(pageList);
    //         setState({
    //             pageData: pageList.data
    //         });
    //     }else{
    //         const pageList = await webapi.get('pages/datapages/703/fa');
    //         //console.log(pageList);
    //         setState({
    //             pageData: pageList.data
    //         });
    //     }
    
    //     const pageHtml = await webapi.get('pages/htmlpages/703/'+LanguageInfo[0].Code);   
    //     //console.log(bodyList);     
    //     setState({
    //         pageHtmlData: pageHtml.data
    //     });
    // }

    const sendContact = async (URL,Data) => {
        //console.log(Data);
        await webapi.post(URL,Data, 
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':"Basic "+ btoa("reza:WE15214HsA522")
                }
            }
        )
                    //.done(function (data) {console.debug(data);});        
    }

    const onSubmit = () => {
        const recaptchaValue = recaptchaRef.current.getValue();
        props.onSubmit(recaptchaValue);
      }

    const sendButtonClick = event =>{
        event.preventDefault();
        if (showSubmit){
            let emailformat = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i
            if ((name)&&(name!=='')&&(name!==null))
            {
                if ((email)&&(email!=='')&&(email!==null)&&(emailformat.test(email)))
                {
                    if ((subject)&&(subject!=='')&&(subject!==null))
                    {
                        sendContact('contactus/send', 
                            JSON.stringify  (
                                {  
                                    Author:name,
                                    Email:email,
                                    Description:subject.replace(/(?:\r|\n|\r\n)/g, '<br>'),
                                    IP:''
                                }
                            )
                        )
                        .then(async response => {
                            NotificationManager.success(pageData.length!==0 && pageData[0].F70311!== undefined?pageData[0].F70311:70311/*'پیام شما با موفقیت ارسال گردید'*/, pageData.length!==0 && pageData[0].F70310!== undefined?pageData[0].F70310:70310/*'ارسال پیام'*/,5000);
                        })
                        .catch(error => {
                            NotificationManager.error(pageData.length!==0 && pageData[0].F70313!== undefined?pageData[0].F70313:70313/*'خطا در ارسال پیام'*/, pageData.length!==0 && pageData[0].F70312!== undefined?pageData[0].F70312:70312/*'خطا'*/, 5000, () => {});
                        });

                        setName('')
                        setEmail('')
                        setSubject('')
                    }
                    else
                    {
                        NotificationManager.warning(pageData.length!==0 && pageData[0].F70315!== undefined?pageData[0].F70315:70315/*'متن پیام خالی است'*/, pageData.length!==0 && pageData[0].F70314!== undefined?pageData[0].F70314:70314/*'ورود اطلاعات'*/, 5000);
                    }
                }
                else
                {
                    NotificationManager.warning(pageData.length!==0 && pageData[0].F70317!== undefined?pageData[0].F70317:70317/*'ایمیل وارد شده معتبر نمی باشد'*/, pageData.length!==0 && pageData[0].F70316!== undefined?pageData[0].F70316:70316/*'ورود اطلاعات'*/, 5000);
                }
            }
            else
            {
                NotificationManager.warning(pageData.length!==0 && pageData[0].F70319!== undefined?pageData[0].F70319:70319/*'نام و نام خانوادگی وارد نشده است'*/, pageData.length!==0 && pageData[0].F70318!== undefined?pageData[0].F70318:70318/*'ورود اطلاعات'*/, 5000);
            }
        }
    }

    const onNameChange = event=> {
        setName(event.target.value)
        //console.log(event.target.value);
    }

    const onEmailChange = event=> {
        setEmail(event.target.value)
        //console.log(event.target.value);
        //console.log(name);
    }

    const onSubjectChange = event=> {
        setSubject(event.target.value)
        //console.log(event.target.value);
    }

    const ReCAPTCHAChanged= (value) =>{
        setShowSubmit(true);
    }
    
    if (languageInfo && pageData && pageHtmlData) {
        return  (
            <div>
                <Header  languageInfo = {languageInfo}/>
                <div className="container-fluid" id="innerpage_row_1">
                    <div className="container">
                        <h1 id="page_title">{pageData.length!==0 && pageData[0].F70300!== undefined?pageData[0].F70300:70300/*تماس با ما*/}</h1>
                    </div>
                </div>

                <div className="container-fluid"  id="contact_form">
                    <div className="container container_70">
                        <form >
                            <label htmlFor="name">{pageData.length!==0 && pageData[0].F70301!== undefined?pageData[0].F70301:70301/*نام و نام خانوادگی*/}</label>
                            <input  type="text" 
                                    id="name" 
                                    name="name" 
                                    placeholder={pageData.length!==0 && pageData[0].F70302!== undefined?pageData[0].F70302:70302/*"Your name..."*/}
                                    value={name || ''}
                                    onChange={onNameChange}
                            />

                            <label htmlFor="email">{pageData.length!==0 && pageData[0].F70303!== undefined?pageData[0].F70303:70303/*ایمیل*/}</label>
                            <input  type="email" 
                                    id="email" 
                                    name="email" 
                                    placeholder={pageData.length!==0 && pageData[0].F70304!== undefined?pageData[0].F70304:70304/*"Your email..."*/}
                                    value={email || ''}
                                    onChange={onEmailChange}
                            />
                                
                            <label htmlFor="subject">{pageData.length!==0 && pageData[0].F70305!== undefined?pageData[0].F70305:70305/*موضوع و متن پیام*/}</label>
                            <textarea   id="subject" 
                                        name="subject" 
                                        placeholder={pageData.length!==0 && pageData[0].F70306!== undefined?pageData[0].F70306:70306/*"Write something..."*/}
                                        value={subject || ''}
                                        onChange={onSubjectChange}
                                    >
                            </textarea>
                            {
                                
                                [
                                    
                                    <div className="captcha_div" onSubmit={onSubmit} >
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6LcmcjwbAAAAAMOmqXnKxl7I8t9gW1fgRFk8sodX"
                                            onChange={ReCAPTCHAChanged}
                                        />
                                    </div>
                                    ,
                                    <input  type="submit" 
                                        className="submit_button" 
                                        value={pageData.length!==0 && pageData[0].F70307!== undefined?pageData[0].F70307:70307/*"ارسال"*/} 
                                        onClick={sendButtonClick}
                                        disabled = {showSubmit}    
                                    />   
                                ]
                            }
                            

                        </form>
                    </div>
                </div>
                <NotificationContainer/>
                <Footer lang = {languageInfo[0].Code}/>
            </div>  
        );
    } else {
        return  null
    }
 }

 export default ContactUs;